//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
    name:'CommonTable',
    props:{
        tableData:Array,
        tableLabel:Array,
        config:Object
    },
data(){
    return {}
},
methods:{
    handleEdit(row){
        this.$emit('edit',row)
    },
    handleDelete(row){
        this.$emit('del',row)
    },
    changePage(page){
        this.$emit('changePage',page)
    }
    
}
}

